<div class="text-warning fw-bold text-center">
  <span class="d-block fs-1"><i class="fa-thin fa-triangle-exclamation"></i></span>
  <span class="fs-2">Die von Ihnen aufgerufene Seite existiert nicht oder der Link ist bereits abgelaufen.</span>
</div>
